<template>
  <div class="inputSearch">

<InputSearch @getData="onInputChange" @change="inputChange" v-model="value" ref='search' @selected='selected' :columns='columns' :loading='loading'
   :autoFocus='true'  :placeHolder='"支持商品编码、通用名、商品名、助记码"'   @on-blur='inputBlur' :data='options'  :reset='false'></InputSearch>
  </div>
</template>
<script>
// import hotkeys from 'hotkeys-js';
import goods from '../../services/goods';
import utils from '../../libs/utils';
import InputSearch from '../InputSearch.vue';
// 此组件相对特殊，仅支持目前引用
export default {
  name: 'goodsDropDown',
  components: { InputSearch },
  props: {
    val: {
      type: [String, Number, Array],
    },
    // autoFocus: {
    //   type: Boolean,
    //   default: false,
    // },
    selectedList: {
      type: Array,
    },
    // type: {
    //   type: Number,
    //   required: true,
    // },
  },
  model: {
    prop: 'val',
    event: 'change',
  },
  watch: {
    val() {
      this.value = this.val;
    },

    type() {

    },
  },
  computed: {

  },
  data() {
    return {
      value: '',
      visible: false,
      selectLoading: false,
      selectedIndex: null,
      loading: false,
      options: [],
      columns: [
        {
          title: '商品名称',
          key: 'goodsBaseGoodsName',
          width: '225px',
        },
        // {
        //   title: '批准文号/注册证号',
        //   key: 'goodsBaseApprovalNumber',
        //   width: '120px',
        // },
        // {
        //   title: '规格',
        //   key: 'goodsBaseSpecifications',
        //   width: '50px',
        // },
        // {
        //   title: '生产厂家',
        //   key: 'goodsBaseManufacturer',
        //   width: '80px',
        // },
      ],

    };
  },
  methods: {
    inputChange(val) {
      console.log(val);
      this.$emit('change', val);
    },
    clear() {
      this.value = null;
      this.$emit('change', null);
    },
    onInputChange(val) {
      if (val) {
        const data = {
          nameMix: val,
          // statusCodeList: [1],
          page: 1,
          size: 100,
          labelIdList: [304],
          type: this.type,
        };
        // this.$store.commit('setDisableLoading', true);
        this.loading = true;
        this.$store.commit('setDisableLoading', true);
        goods.listGoodsStores(data).then((res) => {
          // this.$emit('change', this.value);
          this.loading = false;
          if (res.data.status === 200) {
            // res.data
            this.options = [];
            const { list } = res.data.data;
            const names = [];
            if (list.length) {
              list.forEach((item) => {
                const result = {};

                utils.exchangeTable(item, result);
                // console.log(item.goodsBaseVO.goodsBase.goodsName);

                if (!names.includes(item.goodsBaseVO.goodsBase.goodsName)) {
                  names.push(item.goodsBaseVO.goodsBase.goodsName);
                  result.goodsStoreIdList = [result.goodsStoreId];
                  this.options.push(result);
                }
                // else {
                //   this.options.forEach((option) => {
                //     // console.log(option);

                //     if (option.goodsBaseGoodsName === item.goodsBaseVO.goodsBase.goodsName) {
                //       option.goodsStoreIdList.push(result.goodsStoreId);
                //     }
                //   });
                // }
              });
              // console.log(this.options.map(item => item.goodsStoreIdList));
            }
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          this.loading = false;
          utils.handleError(err);
        });
      } else {
        this.options = [];
        this.visible = false;
        // this.clear();
      }
    },
    // handleClick(){}
    // onDropDownclick(name) {
    //   console.log(name);

    //   if (this.selectLoading || name === 'title' || name === 'noTitle') {
    //     this.selectLoading = false;
    //     this.visible = false;
    //     this.$nextTick(() => {
    //       this.$refs.dropdown.currentVisible = false; // 规避iview组件不能驱动内部参数问题
    //     });
    //   } else {
    //     this.visible = true;

    //     this.selectLoading = true;

    //     if (!Number.isNaN(name)) {
    //       this.selectedIndex = name;
    //       this.seleced();
    //       this.$nextTick(() => {
    //         this.visible = false;
    //       });
    //     }
    //     setTimeout(() => {
    //       this.selectLoading = false;
    //     }, 500);
    //   }
    // },
    inputBlur() {
      this.$emit('on-blur', this.value);
      this.$nextTick(() => {
        this.visible = false;
      });
    },

    selected(val) {
      // this.visible = false;
      // console.log(this.options[this.selectedIndex]);
      this.value = val.goodsBaseGoodsName;
      this.$emit('change', this.value);
      // this.$emit('', val);
    },


  },
  mounted() {

  },
};
</script>
<style lang="less" scoped>
.searchList{
  max-height: 300px;
  overflow: auto;
  // width: 660px;

}
.selected{
  background: #f8f8f8
}
.noTitle{
  .noThing{
  height: 36px;
  line-height: 36px;
  padding-left: 16px;
  color: rgba(0, 0, 0, 0.25)
}

}
.options{
  // width: 660px;
  display: flex;
  align-items: center;
  font-size: 12px;
  >span{
    width: 22%;
    text-align: left;
    word-wrap: none;
    text-overflow: ellipsis;
    overflow: hidden;

  }
  // >span:nth-child(1){
  //   width: 80px
  // }
  >span:nth-child(2){
    width: 180px
  }
  .textOver{
    width: 100%;
    text-align: center;
    word-wrap: none;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
